export default __webpack_public_path__ + "static/media/Summer wreath.80176914.jpg";